import classes from "./PhoneSearch.module.css";
import PhoneInputs from './inputSearchPhone/PhoneInputs.jsx';
import { RemoveScroll } from 'react-remove-scroll';
import { useEffect, useRef } from 'react';

export const PhoneSearch = ({ isOpen, close }) => {
  const prevThemeRef = useRef({ theme: null, status: null });

  useEffect(() => {
    if (!isOpen) return;

    const metaTheme = document.querySelector('meta[name="theme-color"]');
    const metaStatus = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]');

    const prevTheme = metaTheme ? metaTheme.getAttribute('content') : null;
    const prevStatus = metaStatus ? metaStatus.getAttribute('content') : null;

    prevThemeRef.current = { theme: prevTheme, status: prevStatus };

    if (metaTheme) metaTheme.setAttribute('content', '#ffffff');
    if (metaStatus) metaStatus.setAttribute('content', 'default');

    return () => {
      const { theme, status } = prevThemeRef.current;
      if (metaTheme && theme) metaTheme.setAttribute('content', theme);
      if (metaStatus && status) metaStatus.setAttribute('content', status);
    };
  }, [isOpen]);

  return (
    <RemoveScroll enabled={isOpen}>
      <div
        className={`${classes.modalContainer} ${isOpen ? classes.open : ''}`}
        data-phone-search-modal
      >
          <header className={classes.header}>
              <div onClick={close} className={classes.arrowBack}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="21" viewBox="0 0 12 21" fill="none">
                      <path fillRule="evenodd" clipRule="evenodd" d="M11.8232 19.5669L10.2932 20.9941L0.323242 10.0749L10.2932 -0.00585938L11.764 1.48131L3.20565 10.1348L11.8232 19.5669Z" fill="#101010"/>
                  </svg>
              </div>
              <div className={classes.logoContainer}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="52" height="18" viewBox="0 0 52 18" fill="none">
                      <g clipPath="url(#clip0_3063_2877)">
                      <path d="M9.39053 9.11796L8.04559 9.00625C4.71775 8.73986 3.59698 8.39614 3.59698 7.64854C3.59698 6.90094 5.01088 6.48847 7.9249 6.48847C11.0027 6.48847 12.2442 6.89234 12.5028 7.97508L12.5459 8.14694H15.9255L15.891 7.90633C15.5548 5.05341 12.9856 3.66992 8.04559 3.66992C3.10556 3.66992 0.570884 5.02764 0.570884 7.6915C0.570884 10.132 2.5969 11.3092 7.58004 11.7561L8.78703 11.8678C12.089 12.1513 13.3132 12.581 13.3132 13.4403C13.3132 14.377 11.8045 14.8582 8.82152 14.8582C5.44195 14.8582 3.71768 14.2309 3.55387 12.9333L3.52801 12.7443H0.148438V12.9763C0.303622 16.0956 3.13142 17.6767 8.56288 17.6767C13.9943 17.6767 16.348 16.1987 16.348 13.2856C16.348 10.6905 14.3995 9.52184 9.39053 9.11796Z" fill="black"/>
                      <path d="M41.3678 4.09892V9.66726C41.3678 12.7866 39.3073 14.72 35.9967 14.72C32.8844 14.72 31.6688 13.3365 31.6688 9.77898V4.09892H21.2197V0L18.1074 1.30615V13.0444C18.1074 16.284 19.6765 17.6675 23.3578 17.6675C24.6424 17.6675 25.8753 17.4526 26.9184 17.2378L27.0909 17.2034V14.445L26.8322 14.4966C25.4787 14.7716 24.8752 14.8747 23.9096 14.8747C22.125 14.8747 21.2197 14.4536 21.2197 12.1421V6.67686H30.0997L28.4617 7.91427V10.7844C28.4617 15.4848 30.4618 17.6675 34.7466 17.6675C37.5141 17.6675 39.7901 16.7136 41.3678 14.8919V17.2378H44.575V4.09892H41.3678Z" fill="black"/>
                      <path d="M49.0654 7.8044C50.2299 7.8044 51.1739 6.9051 51.1739 5.79575C51.1739 4.68641 50.2299 3.78711 49.0654 3.78711C47.901 3.78711 46.957 4.68641 46.957 5.79575C46.957 6.9051 47.901 7.8044 49.0654 7.8044Z" fill="#DF315A"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_3063_2877">
                      <rect width="51.0642" height="17.6761" fill="white" transform="translate(0.148438)"/>
                      </clipPath>
                      </defs>
                  </svg>
              </div>
          </header>
          {isOpen && <PhoneInputs />}
      </div>
    </RemoveScroll>
  );
};

export default PhoneSearch;